import { apiGet } from '../../api'

export const get_all_groups = () => {
  return apiGet({
    endpoint: 'groups/all_groups'
  })
}
